import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = ["id"]
const _hoisted_2 = { class: "tw-flex tw-flex-col tw-w-full tw-gap-[10px]" }
const _hoisted_3 = { class: "tw-flex tw-justify-between tw-w-full" }
const _hoisted_4 = {
  key: 0,
  class: "custom-global-skeleton tw-w-[36px] tw-h-[22.5px]"
}
const _hoisted_5 = ["id"]
const _hoisted_6 = { class: "tw-flex tw-justify-between tw-w-full" }
const _hoisted_7 = {
  key: 0,
  class: "custom-global-skeleton tw-w-[36px] tw-h-[22.5px]"
}
const _hoisted_8 = ["id", "data-cy"]
const _hoisted_9 = { class: "tw-flex tw-justify-between tw-w-full" }
const _hoisted_10 = {
  key: 0,
  class: "custom-global-skeleton tw-w-[36px] tw-h-[22.5px]"
}
const _hoisted_11 = ["id", "data-cy"]

import { getComponentUiText, getNextDay } from "@/utils/utilities";
import { ComputedRef, PropType, computed, ref } from "vue";
import { getLocale, getTimeFromNow } from "@/utils/dateTimeUtils";
import { IChecklistRequested, IDataEmailGrant } from "@/interfaces/vendor";
import dayjs from "dayjs";


export default /*#__PURE__*/_defineComponent({
  __name: 'vendorShareCard',
  props: {
  detail: {
    type: Object as PropType<IChecklistRequested>,
    default: {} as IChecklistRequested,
    required: false,
  },
  loading: {
    type: Boolean,
    required: false,
    default: false,
  },
  classStyleContent: {
    type: String,
    default: "",
  },
  classStyleIcon: {
    type: String,
    default: "",
  },
  dataEmailGrant: {
    type: Object as PropType<IDataEmailGrant>,
    default: {} as IDataEmailGrant,
    require: false,
  },
},
  setup(__props) {

const props = __props;



const dataEmailGrant: ComputedRef<any> = computed(() => {
  return props.detail?.dataEmailGrant || props?.dataEmailGrant;
});

const isGreyOut: ComputedRef<any> = computed(() => {
  return props.detail?.isArchived;
});
const isHoverExpiryDate = ref(false);
const isHoverShared = ref(false);

const getLastUpdatedTimeFromNow = () => {
  if (!dataEmailGrant.value?.dateEmailSent) return "-";
  return getTimeFromNow(dataEmailGrant.value?.dateEmailSent);
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    id: `vendor-share-card-${__props.detail.checklistRequestedId}`,
    class: "tw-flex"
  }, [
    _createElementVNode("div", {
      class: _normalizeClass([
        'tw-bg-[#FCFCFC] tw-max-h-[112px] tw-min-h-[112px] tw-w-full tw-h-full tw-flex tw-flex-col tw-justify-between tw-items-start tw-flex-[1_0_0] tw-self-stretch tw-border tw-shadow-[0px_0px_4px_0px_rgba(0,0,0,0.05)] tw-p-5 tw-rounded-l-md tw-border-solid tw-border-[#EFF0F1]',
        __props.classStyleContent,
      ])
    }, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("div", {
            class: _normalizeClass(`${
              isGreyOut.value ? 'tw-text-[#878787]' : 'tw-text-[#211F58]'
            } tw-text-[13px] tw-not-italic tw-font-medium tw-leading-[130%] title`)
          }, _toDisplayString(_unref(getComponentUiText)(
                "app-component-assessments-vendor-assessment-share-card-shared-title-1",
              )), 3),
          (__props.loading)
            ? (_openBlock(), _createElementBlock("div", _hoisted_4))
            : (_openBlock(), _createElementBlock("div", {
                key: 1,
                id: `vendor-progress-card-last-updated-${__props.detail.checklistRequestedId}`,
                class: "tw-text-[#878787] tw-text-[13px] tw-font-[400]"
              }, _toDisplayString(getLastUpdatedTimeFromNow()), 9, _hoisted_5))
        ]),
        _createElementVNode("div", _hoisted_6, [
          _createElementVNode("div", {
            class: _normalizeClass(`${
              isGreyOut.value ? 'tw-text-[#878787]' : 'tw-text-[#211F58]'
            } tw-text-[13px] tw-not-italic tw-font-medium tw-leading-[130%] title tw-w-[85px]`)
          }, _toDisplayString(_unref(getComponentUiText)(
                "app-component-assessments-vendor-assessment-share-card-shared-with-title-1",
              )), 3),
          (__props.loading)
            ? (_openBlock(), _createElementBlock("div", _hoisted_7))
            : (_openBlock(), _createElementBlock("div", {
                key: 1,
                class: "tw-text-[#211F58] tw-text-[13px] tw-not-italic tw-font-medium tw-leading-[130%] title tw-overflow-hidden tw-flex-1",
                onMouseover: _cache[0] || (_cache[0] = ($event: any) => (isHoverShared.value = true)),
                onMouseleave: _cache[1] || (_cache[1] = ($event: any) => (isHoverShared.value = false))
              }, [
                _createElementVNode("p", {
                  id: `vendor-progress-card-email-${__props.detail.checklistRequestedId}`,
                  "data-cy": `vendor-progress-card-email-${__props.detail.checklistRequestedId}`,
                  class: _normalizeClass(`${
                isGreyOut.value ? 'tw-text-[#878787]' : 'tw-text-[#387DFF]'
              } tw-text-[13px] tw-font-[400] share-email`)
                }, _toDisplayString(!isGreyOut.value &&
                isHoverShared.value &&
                (dataEmailGrant.value.firstName || dataEmailGrant.value.lastName)
                  ? (dataEmailGrant.value.firstName ? dataEmailGrant.value.firstName : "") +
                    " " +
                    (dataEmailGrant.value.lastName ? dataEmailGrant.value.lastName : "")
                  : dataEmailGrant.value?.recipientEmail ?? "-"), 11, _hoisted_8)
              ], 32))
        ]),
        _createElementVNode("div", _hoisted_9, [
          _createElementVNode("div", {
            class: _normalizeClass(`${
              isGreyOut.value ? 'tw-text-[#878787]' : 'tw-text-[#211F58]'
            } tw-text-[13px] tw-not-italic tw-font-medium tw-leading-[130%] title`)
          }, _toDisplayString(_unref(getComponentUiText)(
                "app-component-assessments-vendor-assessment-share-card-expiry-date-title-1",
              )), 3),
          (__props.loading)
            ? (_openBlock(), _createElementBlock("div", _hoisted_10))
            : (_openBlock(), _createElementBlock("div", {
                key: 1,
                id: `vendor-progress-card-expiry-date-${__props.detail.checklistRequestedId}`,
                "data-cy": `vendor-progress-card-expiry-date-${__props.detail.checklistRequestedId}`,
                class: "tw-text-[#878787] tw-text-[13px] tw-font-[400] tw-cursor-pointer",
                onMouseover: _cache[2] || (_cache[2] = ($event: any) => (isHoverExpiryDate.value = true)),
                onMouseleave: _cache[3] || (_cache[3] = ($event: any) => (isHoverExpiryDate.value = false))
              }, _toDisplayString(dataEmailGrant.value?.validUntil
                ? isHoverExpiryDate.value
                  ? _unref(dayjs)(dataEmailGrant.value?.validUntil)
                      .locale(_unref(getLocale)())
                      .format("DD MMM YYYY")
                  : _unref(getNextDay)(new Date(dataEmailGrant.value?.validUntil))
                : "-"), 41, _hoisted_11))
        ])
      ])
    ], 2)
  ], 8, _hoisted_1))
}
}

})